import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import EntityTable from '../common/entity/entityTable';
import Select from '../common/inputs/select';
import GlassPopup from '../common/interface/glassPopup';
import Button from '../common/inputs/button';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import LocaleTooling from '../../../tooling/localeTooling';

const CalculationsPopup = props => {
  const {
    handleShowPopup,
    fullLoading,
    tableLoading,
    calculationsState,
    handleCalculationsNextPage,
    handleCalculationsDelete,
    handleDownloadCalculationReport,
    handleDownloadCalculationReportCustom,
    handleDownloadCalculationUnifiedReport,
    handleDownloadCalculationUnifiedReportCustom,
    handleDownloadCalculationUnifiedReportReprocess,
    handleDownloadCalculationUnifiedReportCustomReprocess,
    handleRecalculate,
    handleJobInfo,
    hasReprocess,
    popupState,
    handleSelectConnectors,
    customerConnectors,
    currentConnector,
  } = props;
  let customerConnectorsObj = InterfaceTooling.getSelectArrayFromArray(customerConnectors, false);
  let handleAlternativeButton = customerConnectorsObj.length>0 ? handleDownloadCalculationUnifiedReportCustom : false;
  let handleCustomActions = customerConnectorsObj.length>0 ? 
  [handleDownloadCalculationReport, handleDownloadCalculationReportCustom, handleJobInfo, handleRecalculate] : 
  [handleDownloadCalculationReport, handleJobInfo, handleRecalculate];
  let customActionsIcons = customerConnectorsObj.length>0 ? ["file-excel","file-excel","info-circle","retweet"] : ["file-excel","info-circle","retweet"];
  let customActionsTooltips = customerConnectorsObj.length>0 ? 
    [intl.formatMessage({ id: "calculations.tableActions.downloadReport"}),
    intl.formatMessage({ id: "calculations.tableActions.downloadReportCustom"}),
    intl.formatMessage({ id: "calculations.tableActions.info"}),
    LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculations.tableActions.recalculate"}))] : 
    [intl.formatMessage({ id: "calculations.tableActions.downloadReport"}),
    intl.formatMessage({ id: "calculations.tableActions.info"}),
    LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculations.tableActions.recalculate"}))];
  let customActionsForceShow = customerConnectorsObj.length>0 ? [false,false,true,false] : [false,true,false];
  return (
    <GlassPopup
      className="form_popup calculations_popup notifications_popup"
      title={(<FormattedMessage id={"calculations.title"}/>)}
      handleButton={handleDownloadCalculationUnifiedReport}
      buttonText={(<FormattedMessage id={"calculations.downloadReport"}/>)}
      handleAlternativeButton={handleAlternativeButton}
      alternativeButtonText={(<FormattedMessage id={"calculations.downloadReportCustom"}/>)}
      {...props}
    >
      <div>
        <EntityTable
          entityTableDescriptor={hasReprocess ? TableDescriptors.calculationsReprocessList : TableDescriptors.calculationsList}
          data={calculationsState.data}
          loading={tableLoading}
          page={calculationsState.page}
          totalPages={calculationsState.totalPages}
          totalRecords={calculationsState.totalRecords}
          orderBy={calculationsState.orderBy}
          orderByDirection={calculationsState.orderByDirection}
          fetchListChangePage={handleCalculationsNextPage}          
          handleDelete={handleCalculationsDelete}                  
          handleCustomActions={handleCustomActions}
          customActionsIcons={customActionsIcons}
          customActionsTooltips={customActionsTooltips}
          customActionsForceShow={customActionsForceShow}
          showBaseActionsField={hasReprocess ? "is_reprocess" : null}
        />
        {(hasReprocess) && (
          <footer className="reprocess_buttons_wrapper">
            {(customerConnectorsObj.length>0) && (
              <Button
                onClick={handleDownloadCalculationUnifiedReportCustomReprocess}
                labelLocale={(<FormattedMessage id={"calculations.downloadReportCustomReprocess"}/>)}
                className={"alternative_button"}
              />
            )}
            <Button
              onClick={handleDownloadCalculationUnifiedReportReprocess}
              labelLocale={(<FormattedMessage id={"calculations.downloadReportReprocess"}/>)}
            />
          </footer>
        )}
      </div>
      {(customerConnectorsObj.length>0) && (
        <Select
          id="report_type"
          value={currentConnector}
          options={customerConnectorsObj}
          labelLocale={<FormattedMessage id="calculations.selectConnectors"/>}
          onChange={handleSelectConnectors}
          className="calculation_popup_report_select"
        />      
      )}
    </GlassPopup>
  );
};

export default CalculationsPopup;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/calculationsPopup.jsx